import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const AppFooter = () => {
  return (
    <FooterContainer>
      <hr />
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
        }}
      >
        <FooterColumn>
          <FooterElement>
            Thanks to:{" "}
            <a
              href="https://oldschool.runescape.wiki/"
              target="_blank"
              rel="noopener noreferrer"
            >
              OSRS Wiki
            </a>{" "}
          </FooterElement>
          <FooterElement>
            Feeling generous?{" "}
            <a
              href="https://buymeacoffee.com/slayerscape"
              target="_blank"
              rel="noopener noreferrer"
            >
              Support SlayerScape
            </a>
          </FooterElement>
          <FooterElement
            style={{ color: "rgba(255, 255, 255, 0.85)", fontSize: "0.9rem" }}
          >
            © {new Date().getFullYear()} SlayerScape. All rights reserved.
          </FooterElement>
        </FooterColumn>
        <FooterColumn>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms and Conditions</Link>
          <FooterElement>
            RuneScape Old School is a trademark of{" "}
            <a
              href="https://jagex.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Jagex Limited
            </a>
          </FooterElement>
        </FooterColumn>
      </div>
    </FooterContainer>
  );
};

export default AppFooter;

const FooterContainer = styled.footer`
  width: 100%;
  background: transparent !important;
  padding: 0.4rem 0.4rem;
  display: flex;
  flex-direction: column;
  margin-top: auto;

  hr {
    width: 100%;
    margin: 0.2rem 0;
    border: 1px solid #333;
  }

  a {
    color: rgba(255, 255, 255, 0.85);
    font-size: 0.9rem;
  }
`;

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const FooterElement = styled.p`
  margin: 0.2rem 0;
`;
